var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coming-soon-root d-flex align-items-center justify-content-center"},[_c('h6',{staticClass:"mb-0 text-center white"},[_vm._v("\n        "+_vm._s(_vm.$t('tests.tests.comingSoon'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }